module.exports = __webpack_public_path__ + "static/media/truck-icon.61b3ecf6.svg";